import PropTypes from "prop-types";
import React from "react";
import Image from "../image/Image";
import { getImageLink } from "../../../utils/images";
import { decodeText } from "../../../utils/richText";

// Trust items (icon + label) spread evenly across the row, like bergzeit's. Hidden on small
// screens, where the items fold into the mobile menu (MobileOffCanvas).
const TrustBar = ({ items }) => {
    if (!items.length) return null;

    return (
        <div className="shop-header__trust">
            <ul className="container shop-header__trust-items">
                {items.slice(0, 4).map((item, idx) => (
                    <li key={idx} className="shop-header__trust-item">
                        {getImageLink(item.icon) && <Image imageNode={item.icon} className="shop-header__trust-icon" />}
                        <span>{decodeText(item.label)}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

TrustBar.propTypes = {
    items: PropTypes.array,
};

export default TrustBar;